/**
 * Validates that given obj is an IImageSourceModel
 * @param obj
 */
export function isITextSourceModel(obj) {
  return obj && obj.sourceType === 'text';
}